import React, { useState, useCallback } from 'react'
import { InView } from 'react-intersection-observer'
import CreditOptions from '../CreditOptions/CreditOptions'
import * as Styled from './CreditPlanLink.styles'
import { pushEventAndTrack } from '../../helpers/taggingSerializer'

const CreditPlanLink = ({ productInfo, AddToTrolley, digitalDownload, ArgosCardPlan }) => {
  const [show, setShow] = useState(false)
  const showArgosCardTAndC = digitalDownload

  const { periodType, periodDuration, apr } = ArgosCardPlan || {}

  const isBuyNowPayLater = periodDuration > 0

  const creditOptionsProps = {
    productId: productInfo?.partNumber,
    periodType,
    periodDuration,
    isBuyNowPayLater,
    AddToTrolley,
    apr
  }

  const toggleDrawer = useCallback(() => setShow(prevShow => !prevShow), [])

  const onViewportChange = useCallback(inView => {
    if (inView) {
      pushEventAndTrack({
        eventInfo: {
          eventName: 'pdp_creditBannerViewed',
          eventAction: 'Credit Banner Viewed'
        }
      })
    }
  }, [])

  return (
    <>
      <InView as='div' onChange={onViewportChange} threshold={0.5} triggerOnce>
        <Styled.Container
          onClick={toggleDrawer}
          onKeyPress={toggleDrawer}
          role='link'
          tabIndex='0'
          id='credit-card-link'
          data-test='credit-card-link'
        >
          <Styled.Label>
            <Styled.LabelImage
              src='//media.4rgos.it/i/Argos/argos-card-2024'
              width='64'
              height='40'
              data-test='argos-card-label-image'
              alt='argos-card-image'
            />
          </Styled.Label>
          <Styled.TextContainer>
            {periodDuration === 0 ? (
              'Spread the cost with an Argos Card'
            ) : (
              <>
                Pay no interest when you pay your full <br /> balance within {periodDuration}{' '}
                {periodType?.toLowerCase()}*
              </>
            )}
            <Styled.Terms>
              *Representative {apr}% APR variable <Styled.Link>Learn more</Styled.Link>
            </Styled.Terms>
            {showArgosCardTAndC && <Styled.Terms>18+, T&C apply, Credit subject to status.</Styled.Terms>}
          </Styled.TextContainer>
        </Styled.Container>
      </InView>
      <CreditOptions
        data-test='credit-options'
        {...creditOptionsProps}
        show={show}
        toggleCreditOptions={toggleDrawer}
      />
    </>
  )
}

export default CreditPlanLink
